import dayjs from "@/lib/dayjs";
/**
 * 引数の日付の月の最初の日と最後の日を取得する
 */
export function getMonthRangeByDate(date: string) {
	const dayjsDate = dayjs(date);

	const firstDay = dayjs(dayjsDate).startOf("month").format("YYYY-MM-DD");
	const lastDay = dayjs(dayjsDate).endOf("month").format("YYYY-MM-DD");

	return { firstDay, lastDay };
}
